import { apiClient } from "../../api/api"
import { Trello } from "../../types/trello"

const launchQuickbooksAuth = async (t: Trello.PowerUp.IFrame) => {
  const authUrl = await apiClient.getQuickbooksAuthUrl(t)
  window.open(authUrl, "_blank")
}

// Deep link to a customer in QuickBooks Online. QBO resolves this against the
// company the user currently has open, so with multiple companies connected it
// can land on the right page in the wrong company.
const qboCustomerUrl = (qbCustomerId: string) =>
  `https://qbo.intuit.com/app/customerdetail?nameId=${encodeURIComponent(qbCustomerId)}`

export { launchQuickbooksAuth, qboCustomerUrl }
